import { plainText } from '../../../../../../../modules/validators';
import { trimSpacesLeft } from '../../../../../../../modules/formatters';
import { FormVmItemConfigType } from '../../../../../../../infrastructure/form-viewmodel-controller';
import { AudioBridgeProvider, ConnectionType } from '../../../../../../../api/connections.dao';
import { buildConfigList } from '../../../../../../../infrastructure/utils/form-config.utils';

export enum FieldKey {
    TYPE = 'type',
    LABEL = 'label',
    PROVIDER = 'provider',
    CONFERENCE_MODE = 'conferenceMode',
    AUDIO_PROVIDER_ID = 'audioProviderId',
    MEETING_UNIQUE_REFERENCE = 'meetingUniqueReference',
    AUTO_SYNC_ENABLED = 'autoSyncEnabled',
    AUTOMATICALLY_RECORD_ENABLED = 'recordCalls',
}

const DEFAULT_CONFERENCE_MODE_VALUE = 'HOSTS_ONLY';

export const FORM_CONFIG = {
    [FieldKey.TYPE]: {
        labelDescriptor: { id: 'oe.templates.connection.type', defaultMessage: 'Connection Type', description: 'Label text' },
        defaultValue: ConnectionType.AudioBridge,
        readOnly: true
    },
    [FieldKey.LABEL]: {
        labelDescriptor: { id: 'oe.templates.connection.label', defaultMessage: 'Label', description: 'Label text' },
        defaultValue: '',
        validators: [plainText.maxLength.short],
        formatters: [trimSpacesLeft]
    },
    [FieldKey.MEETING_UNIQUE_REFERENCE]: {
        label: 'Unique Reference',
        labelDescriptor: { id: 'oe.connection.uniqueReference', defaultMessage: 'Unique Reference', description: 'Label text' },
        valueOptions: [ { label: 'No Unique Reference', value: 0 }, 1, 2, 3, 4, 5 ],
    },
    [FieldKey.PROVIDER]: {
        labelDescriptor: { id: 'oe.templates.connection.provider', defaultMessage: 'Provider', description: 'Label text' },
        defaultValue: AudioBridgeProvider.TURBOBRIDGE,
        formatters: [trimSpacesLeft]
    },
    [FieldKey.CONFERENCE_MODE]: {
        labelDescriptor: { id: 'oe.templates.connection.conferenceMode', defaultMessage: 'Conference Mode', description: 'Label text' },
        defaultValue: DEFAULT_CONFERENCE_MODE_VALUE,
        validators: [plainText.required, plainText.maxLength.short],
        formatters: [trimSpacesLeft]
    },
    [FieldKey.AUDIO_PROVIDER_ID]: {
        labelDescriptor: { id: 'oe.templates.connection.telephoneNemberSet', defaultMessage: 'Telephone Number Set', description: 'Label text' },
        defaultValue: '',
        validators: [plainText.required],
    },
    [FieldKey.AUTO_SYNC_ENABLED]: {
        defaultValue: false
    },
    // Default enabled for newly added Audio Bridge connections.
    [FieldKey.AUTOMATICALLY_RECORD_ENABLED]: {
        defaultValue: true
    }
};

export const configList: FormVmItemConfigType[] = buildConfigList(FORM_CONFIG);
